import { render, staticRenderFns } from "./IconDribbble.vue?vue&type=template&id=3d04004a&"
import script from "./IconDribbble.vue?vue&type=script&lang=js&"
export * from "./IconDribbble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports